//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TextareaBlock from 'components/combinedBlocks/Textarea.vue';
import InputFormBlock from 'components/combinedBlocks/InputForm.vue';
import DropDown from 'components/blocks/DropDown.vue';
import ButtonBlock from 'components/blocks/Button.vue';
import EnableScroll from 'components/mixins/EnableScroll.vue';

export default {
  block: 'integrationForm',
  props: ['data'],
  mixins: [
    EnableScroll
  ],
  data() {
    return {
      success: false,
      errorModal: false,
      errorModalHtml: '',
      emailInvalid: false,
      mailOrder: true,
      file: null,
      file2: null,
      platforms: {
        formStyle: true,
        label: "Platform",
        default: {text: this.data.selectDefault },
        options: [{text: 'Centra'}, {text: 'Magento Version 2'}, {text: 'Salesforce Commerce Cloud'}, {text: 'Shopify'}, {text: 'WooCommerce'}, {text: 'Other'}]
      },
      disableOtherPlatform: true,
      disableOrderEmail: true,
      form: {
        companyName: null,
        businessContactName: null,
        businessContactEmail: null,
        businessContactPhone: null,
        bankAccount: null,
        accountingEmail: null,
        technicalContactName: null,
        technicalContactEmail: null,
        technicalContactPhone: null,
        platform: null,
        otherPlatform: null,
        platformVersion: null,
        additionalDetails: null,
        useMailOrder: null,
        mailOrderEmail: null,
        logoFiles: [],
      },
      // Dev data to avoid typing in the same info each refresh
      // form: {
      //   companyName: 'Test',
      //   businessContactName: 'Test',
      //   businessContactEmail: 'test@test.com',
      //   businessContactPhone: null,
      //   bankAccount: 'Test',
      //   accountingEmail: 'test@test.com',
      //   technicalContactName: 'Test',
      //   technicalContactEmail: 'test@test.com',
      //   technicalContactPhone: null,
      //   platform: 'Shopify',
      //   otherPlatform: null,
      //   platformVersion: '13',
      //   additionalDetails: null,
      //   useMailOrder: 0,
      //   mailOrderEmail: null,
      //   logoFiles: [],
      // },
      showInvalidNotification: false,
      invalidInputs: {
        companyName: false,
        businessContactName: false,
        businessContactEmail: false,
        businessContactPhone: false,
        bankAccount: false,
        accountingEmail: false,
        technicalContactName: false,
        technicalContactEmail: false,
        technicalContactPhone: false,
        platform: false,
        otherPlatform: false,
        platformVersion: false,
        additionalDetails: false,
        useMailOrder: false,
        mailOrderEmail: false,
        logoFiles: false,
      }
    }
  },
  components: {
    InputFormBlock,
    TextareaBlock,
    ButtonBlock,
    DropDown
  },
  computed: {
    isDropFileUploadSupported: () => {
      // Check support for dragging files, and fileReader
      var div = document.createElement('div');
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    },
  },
  methods: {
    selectPlatform(option){
      this.disableOtherPlatform = (option.text != 'Other');
      this.form.platform = option.text;

      this.notEmpty('platform');
    },
    mailOrderSelection(event){
      if (event.target.value != 'Use mailorder'){
        this.disableOrderEmail = true;
        this.form.useMailOrder = false;
      } else {
        this.disableOrderEmail = false;
        this.form.useMailOrder = true;
      }

      this.isBool('useMailOrder');
    },
    setFiles(event) {
      this.form.logoFiles = Array.from(event.target.files);
      this.notEmpty('logoFiles');
    },
    notEmpty(inputName){
      if (this.form[inputName] == '' || this.form[inputName] == null || this.form[inputName] == []) {
        this.invalidInputs[inputName] = true;
        return false;
      } else {
        this.invalidInputs[inputName] = false;
        return true;
      }
    },
    validEmail(inputName){
      const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/;
      this.form[inputName] = this.notEmpty(inputName) ? this.form[inputName].trim() : '';
      if (!this.notEmpty(inputName)){
        return false;
      } else {
        if(this.form[inputName].match(mailformat)){
          // document.form1.text1.focus();
          this.invalidInputs[inputName] = false;
          return false;
        } else {
          // document.form1.text1.focus();
          this.invalidInputs[inputName] = true;
          return true;
        }
      }
    },
    isBool(inputName){
      if (this.form[inputName] !== false && this.form[inputName] !== true) {
        this.invalidInputs[inputName] = true;
        return false;
      } else {
        this.invalidInputs[inputName] = false;
        return true;
      }
    },
    allFieldsAreValid(){

      this.notEmpty('companyName');

      // Business contact
      this.notEmpty('businessContactName');
      this.validEmail('businessContactEmail');
      // this.notEmpty('businessContactPhone'); // Optional

      // Account
      this.notEmpty('bankAccount');
      this.validEmail('accountingEmail');

      // Technical
      this.notEmpty('technicalContactName');
      this.validEmail('technicalContactEmail');
      // this.notEmpty('technicalContactPhone'); // Optional

      this.notEmpty('platform');

      // Conditional
      if (this.form.platform == 'Other'){
        this.notEmpty('otherPlatform');
      } else {
        this.invalidInputs.otherPlatform = false;
      }

      this.notEmpty('platformVersion');

      // this.notEmpty('additionalDetails'); // Optional

      this.isBool('useMailOrder');

      // Conditional
      if(this.form.useMailOrder)
        this.validEmail('mailOrderEmail');
      else
        this.invalidInputs.mailOrderEmail = false;

      // Logo is optional, we don't force logo to be sent with the form
      this.invalidInputs.logoFiles = false;

      let invalidInputs = false;
      for(var key in this.invalidInputs){
        invalidInputs = invalidInputs || this.invalidInputs[key];
        // console.log("All inputs valid?: ", invalidInputs);
      }


      return !invalidInputs;
    },
    sendMessage() {

      if (!this.allFieldsAreValid()){
        this.showInvalidNotification = true;
        setTimeout(() => {
          this.showInvalidNotification = false;
        }, 5000);
        return;
      } 

      const form = this.$el.querySelector('#form');

      let ajaxData = new FormData(form);
      for (var key in this.form){
        if(key === 'logoFiles') {
          ajaxData.delete(key); // Clear any data gotten from the form
          for(let i = 0; i < this.form[key].length; i++){
            ajaxData.append(key, this.form[key][i]);
          }
        } else{
          ajaxData.append(key, this.form[key]);
        }
      }

      this.$http.post('/api/newcustomer', ajaxData)
        .then(response => {
          this.success = true;
          // console.log("response: ", response);
        })
        .catch(response => {
          if (response.status == 413) {
            this.errorModalHtml = this.data.errorFileTooLargeHtml;
          } else {
            this.errorModalHtml = this.data.errorGenericHtml;
          }
          this.errorModal = true;
          console.error("Failed to post new customer details");
        });
    },
  },
  mounted() {
    this.enableScroll(this.$el.querySelector('.integrationForm-scrollContainer'));

    const label = this.$el.querySelector('.integrationForm-selectFileLabel');

    if (this.isDropFileUploadSupported) {
      label.classList.add('m-dropFileSupport');

      let droppedFiles = false;
      const allDragEvents = ['drag','dragstart','dragend','dragover','dragenter','dragleave','drop'];

      allDragEvents.forEach( function(e){
        window.addEventListener(e, 
          function(e){
            e.preventDefault();
            e.stopPropagation();
          }, false);
      });

      ['dragover','dragenter'].forEach( function(e){
        window.addEventListener(e, function(e){
          label.classList.remove('m-invalid');
          label.classList.add('m-dragover');
      }, false);
      });

      ['dragleave','dragend','drop'].forEach( function(e){
        window.addEventListener(e, function(e){label.classList.remove('m-dragover');}, false);
      });

      ['drop'].forEach( (e) => {
        window.addEventListener(e, (e) => {
          droppedFiles = e.dataTransfer.files;
          this.form.logoFiles = Array.from(droppedFiles);
          this.notEmpty('logoFiles');
        }, false);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/IntegrationForm.vue